import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  LinearProgress,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Typography,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { useEffect, useState } from "react";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { findContentDetail } from "../api/content/ContentAPI";
import timeSince, { timeDuration } from "../util/TimeSince";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import PersonIcon from "@mui/icons-material/Person";
import { useTranslation } from "react-i18next";
import { groupBy, maxByField } from "../util/ArrayUtil";
import { SentimentGauge } from "./SentimentGauge";
import { SentimentMeter } from "./SentimentMeter";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import { VotingComponent } from "./VotingComponent";
type ContentDetailPageProps = {
  id: number;
  popup: boolean;
  onClosePopup: any;
};

type ArticleProps = {
  title: string;
  content: string;
  description: string;
  author: string;
  topic: string;
  url: string;
  source: string;
  crawledAt: string;
};

type EntityProps = {
  entity: string;
  entityType: string;
  elo: number;
  displayType: string;
  maxElo: number;
  positive: number;
  negative: number;
  neutral: number;
};

export function displayEntity(props: EntityProps) {
  var avatar = <MiscellaneousServicesIcon color="success" />;
  if (props.entityType == "LOCATION") {
    var avatar = <LocationOnIcon color="error" />;
  }
  if (props.entityType == "PERSON") {
    avatar = <PersonIcon color="info" />;
  }
  if (props.entityType == "ORGANIZATION") {
    avatar = <WorkspacesIcon color="warning" />;
  }
  return (
    <ListItem
      className="grey-hover"
      style={{ paddingTop: "0px", paddingBottom: "0px", minWidth: "400px" }}
      alignItems="flex-start"
    >
      <ListItemAvatar style={{ marginTop: "4px" }}>
        <Avatar style={{ background: "none" }}>{avatar}</Avatar>
      </ListItemAvatar>
      <ListItemText
        style={{ maxWidth: "25%", width: "25%" }}
        primary={props.entity}
        primaryTypographyProps={{ fontSize: "15px" }}
        secondary={props.displayType}
        secondaryTypographyProps={{ fontSize: "13px" }}
      ></ListItemText>
      <ListItemText sx={{ width: "55%", marginLeft: "10px" }}>
        <SentimentMeter elo={props.elo} sentiment={props} noLabel={true} />
      </ListItemText>
      <ListItemText>
        <VotingComponent
          onLike={() => {}}
          onDislike={() => {}}
          flexDirection="column"
        ></VotingComponent>
      </ListItemText>
    </ListItem>
  );
}

type AdjectiveProps = {
  adjective: string;
  count: number;
};

export function displayAdjective(props: AdjectiveProps) {
  return (
    <ListItem
      className="grey-hover"
      style={{ paddingTop: "0px", paddingBottom: "0px" }}
    >
      <ListItemAvatar style={{ marginTop: "4px" }}>
        <Avatar style={{ background: "none" }}>
          <TipsAndUpdatesIcon color="warning" />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        style={{ maxWidth: "25%", width: "25%" }}
        primary={props.adjective}
        primaryTypographyProps={{ fontSize: "15px" }}
        secondary={"x" + props.count}
        secondaryTypographyProps={{ fontSize: "12px" }}
      ></ListItemText>
      <VotingComponent
        onLike={() => {}}
        onDislike={() => {}}
        flexDirection="row"
      ></VotingComponent>
    </ListItem>
  );
}

export function displayArticle(props: ArticleProps) {
  return (
    <Card sx={{ minWidth: "95vw" }}>
      <CardHeader
        avatar={
          props.url.length > 0 ? (
            <Avatar
              alt={props.source}
              src={
                "https://www.google.com/s2/favicons?domain=" +
                new URL(props.url).hostname +
                "/favicon.ico"
              }
            />
          ) : (
            ""
          )
        }
        title={props.title}
        subheader={timeSince(props.crawledAt)}
        titleTypographyProps={{
          fontSize: "20px",
          fontWeight: 500,
          color: "#1976d2",
        }}
      ></CardHeader>
      <CardContent>
        <Typography variant="h6" fontWeight={600}>
          {props.author}
        </Typography>
        <Typography
          variant="body2"
          fontSize={"15px"}
          fontWeight={400}
          textAlign={"justify"}
        >
          {props.description}
        </Typography>
        <Typography
          marginTop={1}
          variant="body2"
          fontSize={"15px"}
          fontWeight={300}
          textAlign={"justify"}
          sx={{ color: "transparent", textShadow: "0 0 5px rgba(0,0,0,0.5)" }}
        >
          <Link
            href={props.url}
            underline="none"
            target={"_blank"}
            rel="noopener noreferrer"
          >
            <Button
              variant="contained"
              style={{
                position: "absolute",
                margin: "auto",
                left: "0px",
                right: "0px",
                maxWidth: "300px",
              }}
            >
              ĐỌC TIẾP &gt;&gt;
            </Button>
          </Link>

          {props.content.substring(0, 400) + "..."}
        </Typography>
      </CardContent>
    </Card>
  );
}
export function ContentDetailPopup(props: ContentDetailPageProps) {
  const [article, setArticle] = useState({
    title: "",
    content: "",
    description: "",
    author: "",
    topic: "",
    url: "",
    source: "",
    crawledAt: "",
  });
  const [mainContentEntities, setMainContentEntities] = useState([]);
  const { t } = useTranslation(["common", "keyword", "whatsnew"]);
  const [entitySentiments, setEntitySentiments] = useState([]);
  const [adjectives, setAdjectives] = useState([]);
  const [lastEncounter, setLastEncounter] = useState(null);

  useEffect(() => {
    if (props.id != 0) {
      findContentDetail(props.id)
        .then((res) => {
          setArticle(res["article"]);
          setMainContentEntities(res["mainContentEntities"]);
          setEntitySentiments(res["entitySentiments"]);
          setAdjectives(res["adjectives"]);
          setLastEncounter(res["lastEncounter"]);
        })
        .catch((err) => {});
    }
  }, [props.id]);

  var maxElo = maxByField(mainContentEntities, "elo") as never;

  var displayEntities = mainContentEntities.map((entity: EntityProps) => {
    entity["displayType"] = t("keyword:" + entity["entityType"]);
    entity["maxElo"] = maxElo;
    for (let i = 0; i < entitySentiments.length; i++) {
      console.log(i);
      if (entitySentiments[i]["entity"] == entity["entity"]) {
        entity["positive"] = entitySentiments[i]["positive"];
        entity["negative"] = entitySentiments[i]["negative"];
        entity["neutral"] = entitySentiments[i]["neutral"];
      }
    }
    return displayEntity(entity as EntityProps);
  });

  var adjectiveGroups = groupBy(
    adjectives,
    (adjective: any) => adjective.adjective
  );
  var adjectiveProps = [] as any[];
  for (let adj of adjectiveGroups.keys()) {
    console.log(adj);
    adjectiveProps.push({
      count: (adjectiveGroups.get(adj) as any[]).length,
      adjective: adj,
    });
  }
  console.log(adjectiveProps);
  var displayAdjectives = adjectiveProps
    .sort((a, b) => b["count"] - a["count"])
    .slice(0, 5)
    .map((adjective: AdjectiveProps) => {
      return displayAdjective(adjective);
    });

  console.log(displayEntities);
  return article.title.length > 0 ? (
    <Popover
      open={props.popup}
      onClose={props.onClosePopup}
      anchorOrigin={{
        vertical: "center",
        horizontal: "left",
      }}
      sx={{
        marginTop: "35px",
        minHeight: "100vh",
        minWidth: "90vw",
      }}
      PaperProps={{
        sx: {
          minWidth: "95vw",
        },
      }}
    >
      <Grid container xs={12}>
        {displayArticle(article)}
      </Grid>
      <Grid container xs={12}>
        <Grid item xs={4}>
          <List style={{ marginTop: "10px" }}>
            <Typography variant="h6" fontWeight={600} paddingLeft={2}>
              {t("keyword:main_keywords_and_significance")}
            </Typography>
            {displayEntities}
          </List>
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={3.5}>
          <List style={{ marginTop: "10px" }}>
            <Typography variant="h6" fontWeight={600} paddingLeft={2}>
              {t("keyword:related_adjectives")}
            </Typography>
            {displayAdjectives}
          </List>
        </Grid>
        <Grid item xs={0.5}></Grid>
        <Grid item xs={3.5}>
          {lastEncounter != null ? (
            <List style={{ marginTop: "10px" }}>
              <ListItem>
                <ListItemAvatar>
                  <Avatar  style={{marginRight: "10px", backgroundColor:"white"}}>
                    <AccessTimeFilledIcon color="info" ></AccessTimeFilledIcon>
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={t("whatsnew:last_encounter")}
                  secondary={timeSince(lastEncounter["time"])}
                ></ListItemText>
              </ListItem>

              <ListItem>
                <Avatar style={{marginRight: "15px", backgroundColor:"white"}}>
                  <HomeIcon color="warning"></HomeIcon>
                </Avatar>
                <ListItemText
                  primary={t("whatsnew:has_been_on_main_page_for")}
                  secondary={timeDuration(
                    article["crawledAt"],
                    lastEncounter["time"]
                  )}
                ></ListItemText>
              </ListItem>
            </List>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </Popover>
  ) : (
    <div></div>
  );
}
